"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVisibleColumnsWithDependencies = exports.MEASURE_TO_DEPENDENCY_MEASURE_MAP = void 0;
const dbTableCampaign_1 = require("../reporterDb/dbTableCampaign/index.js");
const arrays_1 = require("../../helpers/arrays");
const measuresAsColumns_1 = require("./measuresAsColumns");
//To calculate subtotals (slit row values) of measures where it's more complex than just sum of values, we need to fetch their dependency measures as well. Think, maybe it'd be easier to just fetch subtotals in separate request?..
//For Pcpa we need to fetch skanCoarseRatio, cause it's used in SKAN CV Pcpa calculation but can't be used in query directly
exports.MEASURE_TO_DEPENDENCY_MEASURE_MAP = {
    [dbTableCampaign_1.Metrics.winrate]: [dbTableCampaign_1.Events.bid, dbTableCampaign_1.Events.impression],
    [dbTableCampaign_1.Metrics.ecpm]: [dbTableCampaign_1.Events.spend, dbTableCampaign_1.Events.impression],
    [dbTableCampaign_1.Metrics.ctr]: [dbTableCampaign_1.Events.impression, dbTableCampaign_1.Events.click],
    [dbTableCampaign_1.Metrics.ecpc]: [dbTableCampaign_1.Events.spend, dbTableCampaign_1.Events.click],
    [dbTableCampaign_1.Metrics.ir]: [dbTableCampaign_1.Events.mmpInstall, dbTableCampaign_1.Events.click],
    [dbTableCampaign_1.Metrics.ecpi]: [dbTableCampaign_1.Events.spend, dbTableCampaign_1.Events.mmpInstall],
    [dbTableCampaign_1.Metrics.cpr]: [dbTableCampaign_1.Events.spend, dbTableCampaign_1.Events.reattribution],
    [dbTableCampaign_1.Metrics.cti]: [dbTableCampaign_1.Events.mmpInstall, dbTableCampaign_1.Events.click],
    [dbTableCampaign_1.Metrics.skanCPI]: [dbTableCampaign_1.Events.spend, dbTableCampaign_1.Events.skadInstall],
    [dbTableCampaign_1.Metrics.skanIR]: [dbTableCampaign_1.Events.skadInstall, dbTableCampaign_1.Events.click],
    [dbTableCampaign_1.Metrics.ipm]: [dbTableCampaign_1.Events.mmpInstall, dbTableCampaign_1.Events.impression],
    [dbTableCampaign_1.Metrics.skanIPM]: [dbTableCampaign_1.Events.skadInstall, dbTableCampaign_1.Events.impression],
    [dbTableCampaign_1.Metrics.roas]: [dbTableCampaign_1.Events.revenue, dbTableCampaign_1.Events.spend],
    [dbTableCampaign_1.Metrics.bidFloor]: [dbTableCampaign_1.Metrics.bidfloorSumDividend, dbTableCampaign_1.Events.impression],
    [dbTableCampaign_1.Metrics.skanFineRatio]: [dbTableCampaign_1.Metrics.skanFineRatioDividend, dbTableCampaign_1.Metrics.skanFineRatioDivisor],
    [dbTableCampaign_1.Metrics.skanCoarseRatio]: [dbTableCampaign_1.Metrics.skanCoarseRatioDividend, dbTableCampaign_1.Metrics.skanCoarseRatioDivisor],
    [dbTableCampaign_1.Metrics.skanDigit1Ratio]: [dbTableCampaign_1.Metrics.skanDigit1RatioDividend, dbTableCampaign_1.Metrics.skanDigit1RatioDivisor],
    [dbTableCampaign_1.Metrics.skanDigit2Ratio]: [dbTableCampaign_1.Metrics.skanDigit2RatioDividend, dbTableCampaign_1.Metrics.skanDigit2RatioDivisor],
    [dbTableCampaign_1.Metrics.skanSourceAppIdRatio]: [dbTableCampaign_1.Metrics.skanSourceAppIdRatioDividend, dbTableCampaign_1.Metrics.skanSourceAppIdRatioDivisor],
    [dbTableCampaign_1.Metrics.skanPcpa]: [dbTableCampaign_1.Metrics.skanCoarseRatio],
    [dbTableCampaign_1.DimensionIds.CONVERSION_VALUE]: [dbTableCampaign_1.Metrics.skanCoarseRatio],
    [measuresAsColumns_1.ColumnTypes.AppMeasureCPA]: [dbTableCampaign_1.Events.spend],
    [measuresAsColumns_1.ColumnTypes.AppMeasureCPAV2]: [dbTableCampaign_1.Events.spend],
};
const EMPTY = { columnsWithDeps: [], idsToQueryButHideInUI: new Set() };
const getVisibleColumnsWithDependencies = (orderedColumns, hiddenColumns) => {
    if (!orderedColumns) {
        return EMPTY;
    }
    const visibleColumns = orderedColumns.filter((c) => !(hiddenColumns === null || hiddenColumns === void 0 ? void 0 : hiddenColumns[c.id]));
    //simple events and metrics are already in orderedColumns by default
    const columnsWithDeps = new Set(visibleColumns.map((c) => {
        return c.id;
    }));
    const newDepColumns = [];
    visibleColumns.forEach((column) => {
        var _a;
        let deps = exports.MEASURE_TO_DEPENDENCY_MEASURE_MAP[column.id];
        if (column.value && !deps) {
            //some column types, like DimensionAsMeasurePcpa, has event name in "value" prop
            deps = exports.MEASURE_TO_DEPENDENCY_MEASURE_MAP[(_a = column.value) !== null && _a !== void 0 ? _a : ""];
        }
        if (!deps && column.columnType) {
            //some column types, like CPA, are dependent on other measures
            deps = exports.MEASURE_TO_DEPENDENCY_MEASURE_MAP[column.columnType];
        }
        if (deps) {
            deps.forEach((dep) => {
                columnsWithDeps.add(dep);
                if (exports.MEASURE_TO_DEPENDENCY_MEASURE_MAP[dep]) { //Dependency may has its own dependencies
                    exports.MEASURE_TO_DEPENDENCY_MEASURE_MAP[dep].forEach((subDep) => {
                        columnsWithDeps.add(subDep);
                    });
                }
            });
        }
        // For CPA columns, we need to add Count, Spend columns as well for subtotal calculation
        // These extra columns are only used to query and then to normalize(parse) results from query, so they aren't saved to true orderedColumns in MeasuresContext
        if ((!column.columnType || column.columnType === measuresAsColumns_1.ColumnTypes.Metric || column.columnType === measuresAsColumns_1.ColumnTypes.Event) && column.eventId === dbTableCampaign_1.Metrics.cpa) {
            columnsWithDeps.add(dbTableCampaign_1.Events.spend);
            const existingCountCol = visibleColumns.find((c) => c.eventId === dbTableCampaign_1.Events.sales && (!c.columnType || c.columnType === measuresAsColumns_1.ColumnTypes.Event));
            if (!existingCountCol) {
                const countCol = {
                    id: `dependency count for ${column.id}`, //will be not used anyway
                    label: `dependency count for ${column.id}`, //should not be shown anywhere
                    columnType: measuresAsColumns_1.ColumnTypes.Event,
                    eventId: dbTableCampaign_1.Events.sales,
                };
                newDepColumns.push(countCol);
            }
        }
        if (column.columnType === measuresAsColumns_1.ColumnTypes.AppMeasureCPA) {
            columnsWithDeps.add(dbTableCampaign_1.Events.spend);
            const existingCountCol = visibleColumns.find((c) => c.value === column.value && c.columnType === measuresAsColumns_1.ColumnTypes.AppMeasure);
            if (!existingCountCol) {
                const countCol = {
                    id: `dependency count for ${column.id}`, //will be not used anyway
                    label: `dependency count for ${column.id}`, //should not be shown anywhere
                    columnType: measuresAsColumns_1.ColumnTypes.AppMeasure,
                    value: column.value,
                };
                newDepColumns.push(countCol);
            }
        }
        if (column.columnType === measuresAsColumns_1.ColumnTypes.AppMeasureCPAV2) {
            columnsWithDeps.add(dbTableCampaign_1.Events.spend);
            const existingCountCol = visibleColumns.find((c) => c.eventId === column.eventId && c.columnType === measuresAsColumns_1.ColumnTypes.AppMeasureV2);
            if (!existingCountCol) {
                const countCol = {
                    id: `dependency count for ${column.id}`, //will be not used anyway
                    label: `dependency count for ${column.id}`, //should not be shown anywhere
                    dataMappingId: `dependency count for ${column.id}`,
                    columnType: measuresAsColumns_1.ColumnTypes.AppMeasureV2,
                    eventId: column.eventId,
                };
                newDepColumns.push(countCol);
            }
        }
        //For cohorted CPA columns, need cohorted count column
        if (column.columnType === measuresAsColumns_1.ColumnTypes.Cohorted && column.eventId === dbTableCampaign_1.Metrics.cpa) {
            columnsWithDeps.add(dbTableCampaign_1.Events.spend);
            const existingCountCol = visibleColumns.find((c) => { var _a, _b; return c.eventId === dbTableCampaign_1.Events.sales && c.columnType === measuresAsColumns_1.ColumnTypes.Cohorted && (0, arrays_1.haveSameElements)((_a = c.cohorts) !== null && _a !== void 0 ? _a : [], (_b = column.cohorts) !== null && _b !== void 0 ? _b : []); });
            if (!existingCountCol) {
                const countCol = {
                    id: `dependency count for ${column.id}`, //will be not used anyway
                    label: `dependency count for ${column.id}`, //should not be shown anywhere
                    columnType: measuresAsColumns_1.ColumnTypes.Cohorted,
                    eventId: dbTableCampaign_1.Events.sales,
                    cohorts: column.cohorts
                };
                newDepColumns.push(countCol);
            }
        }
        if (column.columnType === measuresAsColumns_1.ColumnTypes.CohortedAppMeasureCPA) {
            columnsWithDeps.add(dbTableCampaign_1.Events.spend);
            const existingCountCol = visibleColumns.find((c) => c.value === column.value && c.columnType === measuresAsColumns_1.ColumnTypes.CohortedAppMeasure);
            if (!existingCountCol) {
                const countCol = {
                    id: `dependency count for ${column.id}`,
                    label: `dependency count for ${column.id}`,
                    columnType: measuresAsColumns_1.ColumnTypes.CohortedAppMeasure,
                    value: column.value,
                };
                newDepColumns.push(countCol);
            }
        }
        if (column.columnType === measuresAsColumns_1.ColumnTypes.AppMeasureCPAV2 && column.cohortedEventId) {
            columnsWithDeps.add(dbTableCampaign_1.Events.spend);
            const existingCountCol = visibleColumns.find((c) => {
                var _a, _b;
                return c.cohortedEventId === column.cohortedEventId
                    && c.columnType === measuresAsColumns_1.ColumnTypes.AppMeasureV2
                    && (0, arrays_1.haveSameElements)((_a = c.cohorts) !== null && _a !== void 0 ? _a : [], (_b = column.cohorts) !== null && _b !== void 0 ? _b : []);
            });
            if (!existingCountCol) {
                const countCol = {
                    id: `dependency count for ${column.id}`,
                    label: `dependency count for ${column.id}`,
                    dataMappingId: `dependency count for ${column.id}`,
                    columnType: measuresAsColumns_1.ColumnTypes.AppMeasureV2,
                    eventId: column.eventId,
                    cohortedEventId: column.cohortedEventId,
                    cohorts: column.cohorts,
                };
                newDepColumns.push(countCol);
            }
        }
    });
    const existingColumnsWithDeps = orderedColumns.filter((c) => columnsWithDeps.has(c.id));
    //use dependency columns in query but hide them in UI
    const idsToQueryButHideInUI = new Set();
    newDepColumns.forEach((c) => { idsToQueryButHideInUI.add(c.id); });
    existingColumnsWithDeps.forEach((c) => { if (hiddenColumns === null || hiddenColumns === void 0 ? void 0 : hiddenColumns[c.id]) {
        idsToQueryButHideInUI.add(c.id);
    } });
    return { columnsWithDeps: [...existingColumnsWithDeps, ...newDepColumns], idsToQueryButHideInUI };
};
exports.getVisibleColumnsWithDependencies = getVisibleColumnsWithDependencies;
